export default __webpack_public_path__ + "static/media/ilustracao-mulher-com-livro.0dcf08d4.svg";